module.exports = __webpack_public_path__ + "static/banner-mobile-empaques-1c784eca8eee2d08a4e9086543a46c33.webp";